// removed by extract-text-webpack-plugin
module.exports = {"nav-down":"ScrollContainer__nav-down__3OcSg","nav-up":"ScrollContainer__nav-up__1H3Kr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ScrollContainer/ScrollContainer.scss
// module id = 385
// module chunks = 0